import { IconProps } from './interfaces';

export const CloseClearIcon = ({ className }: IconProps) => {
    return (
        <svg className={className} xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20">
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M18.3334 9.99999C18.3334 14.6024 14.6025 18.3333 10.0001 18.3333C5.39771 18.3333 1.66675 14.6024 1.66675 9.99999C1.66675 5.39762 5.39771 1.66666 10.0001 1.66666C14.6025 1.66666 18.3334 5.39762 18.3334 9.99999ZM13.9227 6.0774C14.2481 6.40284 14.2481 6.93048 13.9227 7.25591L11.1786 9.99999L13.9227 12.7441C14.2481 13.0695 14.2481 13.5971 13.9227 13.9226C13.5973 14.248 13.0696 14.248 12.7442 13.9226L10.0001 11.1785L7.25603 13.9226C6.93059 14.248 6.40295 14.248 6.07752 13.9226C5.75208 13.5971 5.75208 13.0695 6.07752 12.7441L8.8216 9.99999L6.07752 7.25591C5.75208 6.93048 5.75208 6.40284 6.07752 6.0774C6.40295 5.75196 6.93059 5.75196 7.25603 6.0774L10.0001 8.82148L12.7442 6.0774C13.0696 5.75196 13.5973 5.75196 13.9227 6.0774Z"
            />
        </svg>
    );
};
